import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap, catchError, finalize } from 'rxjs/operators';
import { InvestigationTypeRepository } from '../../../infrastructure/repositories/investigation-type.repository';
import { InvestigationTypeState } from '../../states/investigation-type.state';
import { DeleteInvestigationTypeResult } from './delete-investigation-type.result';

@Injectable({ providedIn: 'root' })
export class DeleteInvestigationTypeUseCase {
  private readonly _repository = inject(InvestigationTypeRepository);
  private readonly _state = inject(InvestigationTypeState);

  public execute(id: string): Observable<DeleteInvestigationTypeResult> {
    this._state.setDeletingInvestigationType(true);
    this._state.clearError();

    return this._repository.deleteInvestigationType(id).pipe(
      tap(() => this._state.removeInvestigationType(id)),
      map(() => ({ success: true })),
      catchError((error) => {
        this._state.setError(
          error?.error?.message || error?.message || 'Failed to delete investigation type',
        );
        throw error;
      }),
      finalize(() => this._state.setDeletingInvestigationType(false)),
    );
  }
}
